'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'mug-saucer';
var width = 576;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = ['M32 448l448 0 0 64-448 0 0-64z', 'M384 32l-320 0 0 352 384 0 0-96c70.7 0 128-57.3 128-128S518.7 32 448 32l-64 0zm64 64c35.3 0 64 28.7 64 64s-28.7 64-64 64l0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;